import { SmallSelectField } from '@/components/Form';
import { usePerPageConditionAtom } from '@/features/analyze/atoms/pageCondition.atom';
import { INITIAL_PER_PAGE } from '@/features/analyze/constants';
import { useGetAnalyzeMethod } from '@/features/analyze/hooks/useGetAnalyzeMethod';

const PER_PAGE_SETS = {
  search: Array.from({ length: 10 }, (_, i) => ({
    label: (i + 1) * 10,
    value: (i + 1) * 10,
  })),
  treemap: Array.from({ length: 10 }, (_, i) => ({
    label: (i + 1) * 50,
    value: (i + 1) * 50,
  })),
  transition: Array.from({ length: 10 }, (_, i) => ({
    label: (i + 1) * 10,
    value: (i + 1) * 10,
  })),
};

export const PerPageSelect = () => {
  const [perPage, setPerPage] = usePerPageConditionAtom();
  const analyzeMethod = useGetAnalyzeMethod();

  if (!analyzeMethod) return;

  const defaultValue = perPage ?? INITIAL_PER_PAGE[analyzeMethod];

  return (
    <SmallSelectField
      className="text-black"
      options={PER_PAGE_SETS[analyzeMethod]}
      value={{ label: defaultValue, value: defaultValue }}
      isSearchable={false}
      onChange={(newValue) => {
        if (!newValue) return;
        setPerPage(newValue.value);
      }}
      transparent
    />
  );
};
